import { UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import { IRosreestrPart } from 'shared/types/offerData';

import * as styles from './InfoBlock.css';

export const InfoBlock: React.FC<React.PropsWithChildren<IRosreestrPart>> = ({ header, elements }) => {
  return (
    <div className={styles['block']}>
      <div data-testid="col-sub-header" className={styles['sub-header']}>
        <UIHeading2>{header}</UIHeading2>
      </div>

      <div className={styles['parts-container']}>
        {elements.map(({ title, value }) => (
          <div key={title} className={styles['part']}>
            <div className={styles['item']}>
              <UIText1 color="gray60_100">{title}</UIText1>
            </div>

            <div className={styles['item']}>
              <UIText1 color="text-primary-default">{value}</UIText1>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
